import React from 'react';
import styled from 'styled-components';

const ResponsibleBanner = ({ roundBorders = false, textCenter }: Props) => {
	const randomTag = React.useMemo(taglineGenerator, []);

	return (
		<BackgroundWrapper $roundBorders={roundBorders}>
			<Tagline textCenter={textCenter}>{randomTag}</Tagline>
			<CallToAction textCenter={textCenter}>
				For free and confidential support call <a href="tel:1800858858">1800 858 858</a> or visit{' '}
				<a href="https://gamblinghelponline.org.au">gamblinghelponline.org.au</a>
			</CallToAction>
		</BackgroundWrapper>
	);
};

export default ResponsibleBanner;

const BackgroundWrapper = styled.div<{ $roundBorders: boolean }>`
	background-color: white;
	display: flex;
	flex-direction: column;
	padding: 4px;
	color: black;
	border-radius: ${({ $roundBorders }) => ($roundBorders ? '6px' : '0')};
`;

const Tagline = styled.span<{ textCenter?: boolean }>`
	font-weight: bold;
	font-size: 14px;
	text-align: ${({ textCenter }) => (textCenter ? 'center' : 'left')};
`;

const CallToAction = styled.span<{ textCenter?: boolean }>`
	font-size: 12px;
	text-align: ${({ textCenter }) => (textCenter ? 'center' : 'left')};
`;

const taglineGenerator = () => {
	const taglines = [
		"Chances are you're about to lose.",
		"What's gambling really costing you?",
		'Imagine what you could be buying instead.',
		'What are you really gambling with?',
		'Think. Is this a bet you really want to place?',
		'What are you prepared to lose today?',
	];

	const randomTaglineIndex = Math.floor(Math.random() * (taglines.length - 1));
	return taglines[randomTaglineIndex];
};

interface Props {
	roundBorders?: boolean;
	textCenter?: boolean;
}

ResponsibleBanner.defaultProps = {
	roundBorders: false,
};
